<img src="assets/images/logos/dpWorldLogo-ball.svg" tooltip="DP World port data available" [showDelay]="300" *ngIf="hasData" />

<span [style.max-width]="maxWidth">{{name}}</span>

